<lib-shared-spinner></lib-shared-spinner>

<lib-shared-version-banner [appEnvironment]="environment.appEnvironment"></lib-shared-version-banner>

<div (click)="hasDebugging ? appService.debug(): null"
	 class="wrapper-header">

	<img alt="Logo LorenzMesse"
		 height="156"
		 ngSrc="/img/logo.png"
		 priority="true"
		 width="218">

	<div class="title">
		{{ 'Messeanfrage' | translate }}
	</div>

</div>

<div class="separator"></div>

<div class="wrapper-info">

	<div>
		@if (appService.appStatus === 'EDIT') {
			{{ 'Formularfelder, die mit * gekennzeichnet sind, müssen ausgefüllt werden.' | translate }}
		}
	</div>

	@if (appService.appStatus === 'EDIT' && (environment.appEnvironment === AppEnvironmentEnum.LOCAL || environment.appEnvironment === AppEnvironmentEnum.DEV)) {
		<div>
			<button mat-flat-button class="mat-primary" (click)="mockForm()">{{ 'Testdaten einfügen' | translate }}</button>
		</div>
	}

	<div class="lang-select">
		<div [routerLink]="'/de'" [ngClass]="{'active': getCurrentLanguage() === 'de'}">
			<img ngSrc="/img/icon-de.png"
				 alt="Sprache DE"
				 priority="true"
				 width="48"
				 height="32">
		</div>
		<div [routerLink]="'/en'" [ngClass]="{'active': getCurrentLanguage() === 'en'}">
			<img ngSrc="/img/icon-en.png"
				 alt="Sprache EN"
				 priority="true"
				 width="48"
				 height="32">
		</div>
	</div>

</div>

<div class="separator"></div>

<div class="wrapper-content">

	@switch (appService.appStatus) {

		@default {

			<request-request></request-request>

		}
		@case ('SUCCESS') {

			<request-success></request-success>

		}
		@case ('FAILURE') {

			<request-failure></request-failure>

		}

	}

</div>

<div class="separator"></div>

<div class="wrapper-footer">

	<p class="text"
	   [innerHTML]="'Copyright © 2024 Lorenz Messe - ' + ('Ein Geschäftsbereich der' | translate) +  ' <span class=no-wrap>Lorenz Projekte GmbH & Co. KG</span>'">
	</p>

	<p>
		<a href="https://www.lorenz-messe.de/impressum.html" target="_blank">{{ 'Impressum' | translate }}</a>
		<a href="https://www.lorenz-messe.de/datenschutz.html" target="_blank">{{ 'Datenschutz' | translate }}</a>
	</p>

</div>
